import { STATES, ITEM_KINDS } from '../../../constants';

const TITLE = 'Connect TV & Internet';

export const STATE_NAME = STATES.STEP_HOME_SERVICES;

export function HomeServicesConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATE_NAME, {
    url: '/home-services',
    views: {
      '@': {
        template: `<upd-home-services></upd-home-services>`,
      },
    },
    scrollTop: true,
    title: TITLE,
    titleBar: {
      title: TITLE,
      save: 'Average Time Saved: 46 minutes',
      icon: 'connect',
    },
    analytics: {
      page: 'Home Services',
    },
    data: {
      moveItem: {
        type: ITEM_KINDS.HOME_SERVICE,
        singleton: true,
      },
    },
  });
}
